// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nsOz","delete":"styles_delete__27scb","update":"styles_update__346d4","add":"styles_add__rg3lg"};